import { createBrowserRouter, createMemoryRouter, type RouteObject } from 'react-router-dom';
import { AppShell } from '@/app/layout/AppShell';
import { RequireAuth } from '@/auth/RequireAuth';
import { LoginPage } from '@/pages/LoginPage';
import { DashboardPage } from '@/pages/DashboardPage';
import { PositionsListPage } from '@/pages/PositionsListPage';
import { PositionDetailPage } from '@/pages/PositionDetailPage';
import { CandidatesListPage } from '@/pages/CandidatesListPage';
import { CandidateDetailPage } from '@/pages/CandidateDetailPage';
import { SubmissionsListPage } from '@/pages/SubmissionsListPage';
import { SubmissionDetailPage } from '@/pages/SubmissionDetailPage';
import { PartnersListPage } from '@/pages/PartnersListPage';
import { PartnerDetailPage } from '@/pages/PartnerDetailPage';
import { SettingsPage } from '@/pages/SettingsPage';
import { NotFoundPage } from '@/pages/NotFoundPage';
import { RouteErrorPage } from '@/pages/RouteErrorPage';
import { ROUTER_FUTURE } from '@/app/router-future';

/**
 * Route table. Entity pages are children of the authenticated shell; add new routes here.
 * Detail routes take `:id`, which the API accepts as UUID or human ID (DC-J-2026-0012).
 */
export const routes: RouteObject[] = [
  { path: '/login', element: <LoginPage />, errorElement: <RouteErrorPage /> },
  {
    element: <RequireAuth />,
    errorElement: <RouteErrorPage />,
    children: [
      {
        element: <AppShell />,
        children: [
          { index: true, element: <DashboardPage /> },
          { path: 'positions', element: <PositionsListPage /> },
          { path: 'positions/:id', element: <PositionDetailPage /> },
          { path: 'candidates', element: <CandidatesListPage /> },
          { path: 'candidates/:id', element: <CandidateDetailPage /> },
          { path: 'submissions', element: <SubmissionsListPage /> },
          { path: 'submissions/:id', element: <SubmissionDetailPage /> },
          { path: 'partners', element: <PartnersListPage /> },
          { path: 'partners/:id', element: <PartnerDetailPage /> },
          { path: 'settings/*', element: <SettingsPage /> },
          { path: '*', element: <NotFoundPage /> },
        ],
      },
    ],
  },
];

export function createAppRouter() {
  return createBrowserRouter(routes, { future: ROUTER_FUTURE });
}

/** Same route tree in memory (tests). */
export function createTestRouter(initialEntries: string[] = ['/']) {
  return createMemoryRouter(routes, { initialEntries, future: ROUTER_FUTURE });
}
